import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from '@mui/material'
import { faq } from '../../data/landing'

export default function FAQ() {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 10 } }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
          <Typography
            variant="overline"
            sx={{
              display: 'block',
              color: 'rgba(255,255,255,0.55)',
              letterSpacing: '0.12em',
              mb: 1,
            }}
          >
            FAQ
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: '2rem', sm: '2.4rem', md: '3rem' },
              mb: 2,
            }}
          >
            Frequently asked questions
          </Typography>

          <Typography
            sx={{
              maxWidth: 720,
              mx: 'auto',
              color: 'rgba(255,255,255,0.72)',
              lineHeight: 1.8,
              fontSize: { xs: '1rem', md: '1.05rem' },
            }}
          >
            Everything you may want to know before launching a self-service kiosk
            at your location.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gap: 2,
          }}
        >
          {faq.map((item, index) => (
            <Accordion
              key={item.q}
              disableGutters
              elevation={0}
              sx={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.08)',
                color: '#fff',
                borderRadius: '18px !important',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
                transition: 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease',
                '&:before': {
                  display: 'none',
                },
                '&:hover': {
                  borderColor: 'rgba(255,255,255,0.14)',
                  boxShadow: '0 16px 40px rgba(0,0,0,0.18)',
                },
                '&.Mui-expanded': {
                  my: 0,
                  borderColor: 'rgba(255,255,255,0.16)',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.045), rgba(255,255,255,0.025))',
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'rgba(255,255,255,0.06)',
                      border: '1px solid rgba(255,255,255,0.08)',
                    }}
                  >
                    <ExpandMoreRoundedIcon sx={{ color: '#fff', fontSize: 22 }} />
                  </Box>
                }
                aria-controls={`faq-content-${index}`}
                id={`faq-header-${index}`}
                sx={{
                  px: { xs: 2.5, md: 3 },
                  py: 0.5,
                  minHeight: 80,
                  '& .MuiAccordionSummary-content': {
                    my: 2,
                    pr: 2,
                  },
                  '& .MuiAccordionSummary-content.Mui-expanded': {
                    my: 2,
                  },
                  '& .MuiAccordionSummary-expandIconWrapper': {
                    color: '#fff',
                    transition: 'transform 0.25s ease',
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    lineHeight: 1.4,
                    fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem' },
                    color: '#fff',
                  }}
                >
                  {item.q}
                </Typography>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  px: { xs: 2.5, md: 3 },
                  pb: 3,
                  pt: 0,
                }}
              >
                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.72)',
                    lineHeight: 1.8,
                    fontSize: '0.98rem',
                    maxWidth: '95%',
                  }}
                >
                  {item.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  )
}